module.exports = __webpack_public_path__ + "img/btn__arrow__grey.e2041e81.svg";